module.exports = __webpack_public_path__ + "assets/img/btn-view-293cc725.png";